module.exports = __webpack_public_path__ + "042ffb2466b865a755c01233f281973a.pdf";